import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from './utils/notification.service';

// @Injectable()
// export class ErrorInterceptor implements HttpInterceptor {
//     public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//         return next.handle(req).pipe(
//             catchError(err => {
//               debugger;
//                 if (err instanceof HttpErrorResponse && err.error instanceof Blob && err.error.type !== "application/json") {
//                     return new Promise<any>((resolve, reject) => {
//                         let reader = new FileReader();
//                         reader.onload = (e: Event) => {
//                             try {
//                               debugger;
//                                 const errmsg = JSON.parse((<any>e.target).result);
//                                 reject(new HttpErrorResponse({
//                                     error: errmsg,
//                                     headers: err.headers,
//                                     status: err.status,
//                                     statusText: err.statusText,
//                                     url: err.url
//                                 }));
//                             } catch (e) {
//                               debugger;
//                                 console.log(e);
//                                 reject(err);
//                             }
//                         };
//                         reader.onerror = (e) => {
//                           debugger;
//                             console.log(e);
//                             reject(err);
//                         };
//                         debugger;
//                         reader.readAsText(err.error);
//                     });
//                 }
//                 debugger;
//                 return throwError(err);
//             }));
//     }
// }

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private notify: NotificationService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
          if ('application/json' === err.headers.get('Content-Type')) {
                   debugger;
                  //this.notify.showError(err.error[0].join());
                  if(err.error[0]==undefined)
                  {
                    this.notify.showError(err.message);
                  }
                  else{
                    this.notify.showError(err.error[0]);
                  }
                  
                  return throwError(err);
            // const reader = new FileReader();
            // reader.addEventListener('loadend', (e) => {
            //     const data = JSON.parse(e.srcElement['result']);
            //     if (data && data.error) {
            //     this.notify.showError(data.error);
            //     return throwError(err);
            //     }
            //     this.notify.showError(data[0].join());
            //     return throwError(data);
            // });
            // reader.readAsText(err.error);
          }
          return throwError(err);
        }));
    }
}
